import { gql } from '@apollo/client'

export const DUPLICATE_DASHBOARD_MUTATION = gql`
  mutation duplicateJobAndReport($jobId: ID!) {
    duplicateWorkspaceJob(duplicateWorkspaceJobInput: { workspaceJobId: $jobId }) {
      code
      success
      title
      message
    }
  }
`
